module.exports = __webpack_public_path__ + "static/Image20@2x-4786dd7a73c39f5a118929572081fc08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image20@2x.jpg
// module id = 913
// module chunks = 227233210825294 244429959259914